import { IAutomationAppComponent } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel,ConfigurationPanel } from '.';
import { ListPanel } from "./ListPanel";
import { MdTimeline } from "react-icons/md";
import {SideviewPanel} from "./SideviewPanel";


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: MdTimeline,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    ListPanel: ListPanel,
    isSmartApp: true,
    createConfig:  {
        group: 'Functions',
        name: "Controlled Shift function with 4 Points",
        description: "Controlled Shift function 4 point",
        panel: OverviewPanel,
        defaultState: { actSetpoint: 20.1 },
        defaultProperties: [
            { key: 'FlowMax', value: 35 },
            { key: 'Flow2', value: 32 },
            { key: 'Flow1', value: 29 },
            { key: 'FlowBase', value: 22 },
            { key: 'OutTMax', value: -15 },
            { key: 'OutT2', value: -5 },
            { key: 'OutT1', value: 5 },
            { key: 'OutTBase', value: 20 },
            { key: 'BaseTemperature', value: 21 },
            { key: 'Factor', value: 1 },
            { key: 'MaxOffsetRT', value: 3 },
            { key: 'MaxRTCorrection', value: 5 },
            { key: 'FactorForecast', value: 1 },
            { key: 'TempNextDayMin', value: 0 },
            { key: 'TempNextDayMax', value: 0 },
            { key: 'EnableForecast', value: true },
            { key: 'CorrectionTempForecast', value: 1 }
        ]
    },

}